import { CSSProperties } from 'react';

const fadeInOutMotion = (options?: { display?: CSSProperties['display'] }) => {
  const { display = 'block' } = options || {};
  return {
    'fade-in': {
      opacity: 1,
      display,
    },
    'fade-out': {
      opacity: 0,
      transitionEnd: {
        display: 'none',
      },
    },
  };
};

export default fadeInOutMotion;
